import { render, staticRenderFns } from "./banQueryRefactor.vue?vue&type=template&id=0f1d5ada&scoped=true"
import script from "./banQueryRefactor.vue?vue&type=script&lang=js"
export * from "./banQueryRefactor.vue?vue&type=script&lang=js"
import style0 from "./banQueryRefactor.vue?vue&type=style&index=0&id=0f1d5ada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d5ada",
  null
  
)

export default component.exports